import { FC } from 'react';
import { Display } from '@livechat/design-system-react-components';

import { Product } from 'types/product';
import Location from 'services/Location';

import contextEventHeader from '_assets/images/product-logos-text/context-event-logo-text.png';

import { logoContainer, logoStyles, logoText } from './styles';

const textLogo = 'https://cdn.static-text.com/text-brand-assets/logo/text/text-black.svg';
const lcHeader =
  'https://cdn.static-text.com/text-brand-assets/logo/products/horizontal/livechat-text-default.svg';
const cbHeader =
  'https://cdn.static-text.com/text-brand-assets/logo/products/horizontal/chatbot-text-default.svg';
const hdHeader =
  'https://cdn.static-text.com/text-brand-assets/logo/products/horizontal/helpdesk-text-default.svg';
const kbHeader =
  'https://cdn.static-text.com/text-brand-assets/logo/products/horizontal/knowledgebase-text-default.svg';
const owHeader =
  'https://cdn.static-text.com/text-brand-assets/logo/products/horizontal/openwidget-text-default.svg';
// const platformHeader = 'https://cdn.static-text.com/text-brand-assets/logo/products/horizontal/platform-text-default.svg';
const ppHeader = 'https://cdn.static-text.com/text-brand-assets/logo/text/text-black.svg';

interface ILogoDetails {
  src: string | null;
  alt: string;
}

const getLogoDetails = (product): ILogoDetails => {
  if (Location.getUrlParam('client_id') === import.meta.env.VITE_APP_CONTEXT_EVENT_CLIENT_ID) {
    return { src: contextEventHeader, alt: 'Context Event logo' };
  }

  switch (product) {
    case Product.LiveChat:
      return { src: lcHeader, alt: 'LiveChat logo' };
    case Product.HelpDesk:
      return { src: hdHeader, alt: 'HelpDesk logo' };
    case Product.KnowledgeBase:
      return { src: kbHeader, alt: 'KnowledgeBase logo' };
    case Product.ChatBot:
      return { src: cbHeader, alt: 'ChatBot logo' };
    case Product.OpenWidget:
      return { src: owHeader, alt: 'OpenWidget logo' };

    // Platform release: remember to comment out proper case with import when product will go live
    // case Product.Platform:
    //   return { src: platformHeader, alt: 'Platform logo' };

    case Product.PartnerProgram:
      return { src: ppHeader, alt: 'Partner Program logo' };
    default:
      return { src: textLogo, alt: 'Logo of every Text product' };
  }
};

export enum LogoSize {
  SMALL = 'small',
  X_SMALL = 'x-small',
  MEDIUM = 'medium',
  LARGE = 'large',
  FIT = 'fit',
}

type Props = {
  product: Product;
  size?: LogoSize;
  onClick?: () => void;
};

export const LogoWithText: FC<Props> = ({ product, size, onClick }) => {
  const productLogo = getLogoDetails(product);

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  if (product === Product.PartnerProgram) {
    return (
      <div css={logoContainer}>
        <img
          css={logoStyles(product, size)}
          src={productLogo.src}
          alt={productLogo.alt}
          onClick={handleClick}
        />
        <Display size="sm" css={logoText}>
          Partners
        </Display>
      </div>
    );
  }

  return (
    <img
      css={logoStyles(product, size)}
      src={productLogo.src}
      alt={productLogo.alt}
      onClick={handleClick}
    />
  );
};
